export interface NedbetalingsplanList {
    avdrag: number;
    innbetaling: number;
    renterOgGebyr: number;
    restgjeld: number;
    termin: number;
}

export const calculateAnnuitetsbeloep = (
    laanebeloep: number,
    rente: number,
    antallAar: number,
    termingebyr: number,
): number => {
    const r = rente / 100 / 12; // månedlig rente
    const n = antallAar * 12; // totalt antall betalingsperioder

    const annuitet = (laanebeloep * r * (1 + r) ** n) / ((1 + r) ** n - 1) + termingebyr;
    return Math.round(annuitet);
};

const calculateInnbetaling = (foersteTermin: boolean, etabeleringsgebyr: number, annuitetsbeloep: number): number => {
    return foersteTermin ? etabeleringsgebyr : annuitetsbeloep;
};

const calculateRenteOgGebyr = (
    foersteTermin: boolean,
    etabeleringsgebyr: number,
    restGjeld: number,
    terminrente: number,
    termingebyr: number,
): number => {
    return foersteTermin ? etabeleringsgebyr : Math.round(restGjeld * terminrente + termingebyr);
};

const calculateNedbetalingsplan = (
    laanebeloep: number,
    rente: number,
    antallAar: number,
    termingebyr: number,
    etabeleringsgebyr: number,
): NedbetalingsplanList[] => {
    let restGjeld = laanebeloep;
    const nedbetalingsplan: NedbetalingsplanList[] = [];
    const terminrente = rente / 100 / 12;
    const antallTerminer = antallAar * 12;
    const annuitetsbeloep = calculateAnnuitetsbeloep(laanebeloep, rente, antallAar, termingebyr);

    for (let t = 0; t <= antallTerminer; t += 1) {
        const innbetaling = calculateInnbetaling(t === 0, etabeleringsgebyr, annuitetsbeloep);
        const renteOgGebyr = calculateRenteOgGebyr(t === 0, etabeleringsgebyr, restGjeld, terminrente, termingebyr);
        const avdrag = t === 0 ? 0 : innbetaling - renteOgGebyr;
        restGjeld -= avdrag;
        nedbetalingsplan.push({
            termin: t,
            innbetaling,
            avdrag,
            renterOgGebyr: renteOgGebyr,
            restgjeld: restGjeld > 100 ? restGjeld : 0,
        });
    }

    const nedbetalingsplanAar: NedbetalingsplanList[] = [];
    for (let a = 0; a < antallTerminer + 1; a += 12) {
        const aarligPlan = nedbetalingsplan.slice(a, a + 12);
        nedbetalingsplanAar.push({
            termin: Math.floor(a / 12) + 1,
            innbetaling: aarligPlan.reduce((sum, p) => sum + p.innbetaling, 0),
            avdrag: aarligPlan.reduce((sum, p) => sum + p.avdrag, 0),
            renterOgGebyr: aarligPlan.reduce((sum, p) => sum + p.renterOgGebyr, 0),
            restgjeld: aarligPlan[aarligPlan.length - 1]?.restgjeld || 0,
        });
    }

    return nedbetalingsplanAar;
};

export default calculateNedbetalingsplan;
